"use client"

import pino from 'pino'


export const debugKey = "logging.enable_debug"

const logger = pino({
  browser: {
    asObject: true
  },
  level: "info",
})

export const setLogLevel = (debug: boolean) => {
  logger.level = debug ? "debug" : "info";
};

export default logger
